import { Warehouse } from "@mui/icons-material";
import { Input } from "@mui/material";
import { channelTypes, wearHouses } from "components/PimDashboard/DashboardComponents/Buying/BuyingSheet/data";
import { isNew } from "components/PimDashboard/DashboardComponents/Designer/CreateStyle/data";
import { arrType, constraints, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { size } from "lodash";

export const whQtyTableTypes = {
	qty_size_split: { name: "Qty Size Split", key: "qty_size_split" },
	channel_wh_qty_split: { name: "Channel Wh Qty Split", key: "channel_wh_qty_split" },
};

export const ocSplitQtyChannelSizeAssocObj = "ocSplitQtyChannelSizeSplit";
export const ocSplitQtyCutQtySplitAssocObj = "ocSplitQtyCutQtySplit";
export const ocSplitQtyChannelWarehouseAssocObj = "ocSplitQtyChannelSizeWhSplit";

export const sizesList = ["XS/ 28", "S/ 30", "M/ 32", "L/ 34", "XL/ 36", "2XL/ 38", "3XL/ 40"];

export const splitQtyTableColumns = {
	style_ref_no: {
		name: "Style Ref No",
		key: "style_ref_no",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
	},
	sizes: {
		name: "Sizes",
		key: "sizes",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 2,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptionsKeyName]: {
			type: arrType,
			list: sizesList.map((size) => ({ name: size, key: size })),
		},
	},
	warehouses: {
		name: "Warehouses",
		key: "warehouses",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 3,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptionsKeyName]: {
			type: arrType,
			list: wearHouses ? Object.values(wearHouses) : [],
		},
	},
	channels: {
		name: "Channels",
		key: "channels",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 4,
		group: "",
		placeholder: "",
		default_value: "",
		[selectOptionsKeyName]: {
			type: arrType,
			list: channelTypes ? Object.values(channelTypes) : [],
		},
	},
};

export const cutQtyPrefilledColumn = {
	name: "Cut Qty prefilled",
	key: "cut_qty_prefilled",
	input_type: inputTypes.AUTO_GENERATE.key,
	data_type: datatypes.BOOLEAN.key,
	constraints: { NOTNULL: true, DISPLAY: true },
	default_value: 0,
};

export const totalSizeRatioColumn = {
	name: "Total Size Ratio",
	key: "total_size_ratio",
	input_type: inputTypes.AUTO_GENERATE.key,
	data_type: datatypes.DECIMAL.key,
	constraints: { NOTNULL: true, DISPLAY: true },
	default_value: 0,
};

export const splitQtySectionTypes = {
	base_data: { name: "Base Data", key: "base_data" },
	order_qty_input: { name: "Order Qty", key: "order_qty_input" },
};

export const generateAssocDataBasedOnMainDetailsChange = (data) => {
	const warehouses = data?.[splitQtyTableColumns.warehouses.key];
	const sizes = data?.[splitQtyTableColumns.sizes.key];
	const channels = data?.[splitQtyTableColumns.channels.key];

	let channelSizesAssoc = [];
	let chSizeWhRatio = [];
	let allChCutQtyRowsAssoc = [];

	const currentChSizeDataObj = {};
	const currentChSizeWhDataObj = {};
	const currentAllChCutQtyRowsAssoc = {};

	data[ocSplitQtyChannelSizeAssocObj].forEach((chSize) => {
		currentChSizeDataObj[`${chSize.channel}=${chSize.size}`] = chSize;
		if (chSize[ocSplitQtyChannelWarehouseAssocObj])
			chSize[ocSplitQtyChannelWarehouseAssocObj].forEach((chSizeWh) => {
				currentChSizeWhDataObj[`${chSize.channel}=${chSize.size}=${chSizeWh.warehouse}`] = chSizeWh;
			});
	});
	data[ocSplitQtyCutQtySplitAssocObj].forEach((chSize) => {
		currentAllChCutQtyRowsAssoc[chSize.size] = chSize;
	});
	channels.forEach((ch) => {
		sizes.forEach((size) => {
			const chSizeKey = `${ch}=${size}`;
			if (!currentChSizeDataObj[chSizeKey]) {
				channelSizesAssoc.push({
					channel: ch,
					size_qty_precent: 0,
					size: size,
					cut_qty: 0,
					cut_qty_percent: 0,
					size_qty: 0,
					channel_total_qty: 0,
					channel_store_grade: "",
					[ocSplitQtyChannelWarehouseAssocObj]: warehouses.map((row) => ({
						warehouse: row,
						qty: 0,
						warehouse_qty_precent: 0,
					})),
				});
			} else
				channelSizesAssoc.push({
					...currentChSizeDataObj[chSizeKey],
					[ocSplitQtyChannelWarehouseAssocObj]: warehouses.map((wh) => {
						const chSizeWhKey = `${ch}=${size}=${wh}`;
						if (!currentChSizeWhDataObj[chSizeWhKey]) {
							return {
								warehouse: wh,
								qty: 0,
								warehouse_qty_precent: 0,
							};
						} else return currentChSizeWhDataObj[chSizeWhKey];
					}),
				});

			return;
		});
	});

	sizes.forEach((size) => {
		if (!currentAllChCutQtyRowsAssoc[size]) {
			allChCutQtyRowsAssoc.push({
				size: size,
				cut_qty: 0,
				cut_qty_percent: 0,
			});
		} else allChCutQtyRowsAssoc.push(currentAllChCutQtyRowsAssoc[size]);
	});
	return {
		[ocSplitQtyChannelSizeAssocObj]: channelSizesAssoc,
		[ocSplitQtyChannelWarehouseAssocObj]: chSizeWhRatio,
		[ocSplitQtyCutQtySplitAssocObj]: allChCutQtyRowsAssoc,
	};
};

export const splitQtyDummyData = {
	[splitQtyTableColumns.style_ref_no.key]: "ABC123",
	[splitQtyTableColumns.sizes.key]: [sizesList[0], sizesList[1]],
	[splitQtyTableColumns.warehouses.key]: [wearHouses.GGN.key],
	[splitQtyTableColumns.channels.key]: [channelTypes.EBO.key],
	[cutQtyPrefilledColumn.key]: true,
	[ocSplitQtyChannelSizeAssocObj]: [
		{
			id: 1,
			channel: channelTypes.EBO.key,
			size_qty_precent: 0,
			size: sizesList[0],
			cut_qty: 0,
			cut_qty_percent: 0,
			size_qty: 0,
			channel_total_qty: 0,
			channel_store_grade: "",
			[ocSplitQtyChannelWarehouseAssocObj]: [
				{
					id: 1,
					warehouse: wearHouses.GGN.key,
					qty: 0,
					warehouse_qty_precent: 0,
				},
			],
		},
		{
			id: 2,
			channel: channelTypes.EBO.key,
			size_qty_precent: 0,
			size: sizesList[1],
			cut_qty: 0,
			cut_qty_percent: 0,
			size_qty: 0,
			channel_total_qty: 0,
			channel_store_grade: "",
			[ocSplitQtyChannelWarehouseAssocObj]: [
				{
					id: 1,
					warehouse: wearHouses.GGN.key,
					qty: 0,
					warehouse_qty_precent: 0,
				},
			],
		},
	],
	[ocSplitQtyCutQtySplitAssocObj]: [
		{
			size: sizesList[0],
			cut_qty: 0,
			cut_qty_percent: 0,
		},
		{ size: sizesList[1], cut_qty: 0, cut_qty_percent: 0 },
	],
};
